import { render, staticRenderFns } from "./BusinessDataChangeList.vue?vue&type=template&id=521fe628"
import script from "./BusinessDataChangeList.vue?vue&type=script&lang=js"
export * from "./BusinessDataChangeList.vue?vue&type=script&lang=js"
import style0 from "./BusinessDataChangeList.vue?vue&type=style&index=0&id=521fe628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports